import { createReducer, on } from '@ngrx/store';
import {
  failStatus,
  initialStatus,
  loadingStatus,
  successStatus,
} from '@core/models/request-status.model';
import {
  clearProductList,
  getProductList,
  setProductList,
  setProductListFacetApplied,
  setProductListFail,
  setProductListSuccess,
  setSpecificProductOnList,
} from '@b2b/features/product/core/store/actions/product-list.actions';
import { FACET_TYPE, ProductListState } from '@b2b/features/product/core/utilities/product-list.model';

const initialState: ProductListState = {
  products: {
    data: {
      currentPage: 0,
      totalPages: 0,
      totalProducts: 0,
      products: [],
    },
    ...initialStatus,
  },
  facetGroups: {
    data: [
      {
        type: FACET_TYPE.CHECKBOX,
        code: '',
      },
    ],
    ...initialStatus,
  },
  pagination: undefined,
  appliedFacets: [],
};

export const productListReducer = createReducer(
  initialState,

  on(clearProductList, (): ProductListState => {
    return initialState;
  }),

  on(getProductList, (state: ProductListState): ProductListState => {
    const response: ProductListState = {
      ...state,
      products: {
        ...state.products,
        ...loadingStatus,
      },
      facetGroups: {
        ...state.facetGroups,
        ...loadingStatus,
      },
    };

    return response;
  }),

  on(setProductListSuccess, (_state: ProductListState, { data }): ProductListState => {
    const response: ProductListState = {
      ..._state,
      products: {
        data: data.data,
        ...successStatus,
      },
      facetGroups: data.facetsGroups,
    };

    return response;
  }),

  on(setSpecificProductOnList, (_state: ProductListState, { product, index }): ProductListState => {
    const currentProducts = _state.products?.data?.products || [];

    const newProducts = [...currentProducts];
    newProducts[index] = product;

    const response = {
      ..._state,
      products: {
        ..._state.products,
        data: {
          ..._state.products?.data,
          products: newProducts,
        },
      },
    };

    return response as ProductListState;
  }),

  on(setProductList, (_state: ProductListState, { products }): ProductListState => {
    const response = {
      ..._state,
      products: {
        ..._state.products,
        data: {
          ..._state.products?.data,
          products,
        },
      },
    };

    return response as ProductListState;
  }),

  on(setProductListFail, (_state: ProductListState, { erroMessage }): ProductListState => {
    const response: ProductListState = {
      ..._state,
      products: {
        ...failStatus,
        message: erroMessage,
      },
    };

    return response;
  }),

  on(setProductListFacetApplied, (_state: ProductListState, { appliedFacets }): ProductListState => {
    const response: ProductListState = {
      ..._state,
      appliedFacets,
    };

    return response;
  }),
);
